<div class="main {{ route?.name.toLowerCase() }}" data-snap-content>
  <ab-header [rendering]="route"></ab-header>

  <sc-placeholder name="ab-account-banner" [rendering]="route"></sc-placeholder>

  <ng-container
    *ngIf="state === LayoutState.Layout || state === LayoutState.NotFound"
  >
    <app-visitor-identification></app-visitor-identification>
    <main class="container gutter-bottom">
      <sc-placeholder name="ab-content" [rendering]="route"></sc-placeholder>
    </main>
  </ng-container>

  <app-server-error *ngIf="state === LayoutState.Error"></app-server-error>

  <ab-footer-wrapper [rendering]="route"></ab-footer-wrapper>
</div>
